import { LuCalculator } from 'react-icons/lu';

import VInput from '../VInput.jsx';
import VInputGroup from '../VInputGroup.jsx';
import { calculateExpression } from './calculateExpression';

export default function VCalculatorInput({
  value,
  onValueChange,
  onBlur = undefined,
  formatResult = String,
  ...props
}) {
  const handleBlur = (event) => {
    onBlur?.(event);
    onValueChange(calculateExpression(value, formatResult));
  };

  return (
    <VInputGroup startElement={<LuCalculator title="Calculator" />}>
      <VInput
        {...props}
        value={value}
        onChange={(event) => onValueChange(event.target.value)}
        onBlur={handleBlur}
      />
    </VInputGroup>
  );
}
